import React from 'react';
import { Box, Button, Stack } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { InputWrapperProps, useInputHelper } from 'framework/form';
import CardIdentityDocumentInput from './CardIdentityDocumentInput';

const CardIdentityDocumentListInput = ({ source, ...props }: InputWrapperProps) => {
  const { getValue, getRawOnChangeCallback } = useInputHelper({ source, ...props });
  const documents = getValue() || [];
  const onChange = getRawOnChangeCallback();

  const addDocument = () => {
    const newDocuments = [...documents, {}];
    onChange?.({ [source]: newDocuments });
  };

  const removeDocument = (index: number) => {
    const newDocuments = documents.filter((_: unknown, i: number) => i !== index);
    onChange?.({ [source]: newDocuments });
  };

  const updateDocument = (index: number, documentData: any) => {
    const newDocuments = [...documents];
    newDocuments[index] = documentData;
    onChange?.({ [source]: newDocuments });
  };

  return (
    <Box sx={{ width: '100%', overflow: 'visible' }}>
      <Stack spacing={2}>
        {documents.map((document: any, index: number) => (
          <CardIdentityDocumentInput
            key={source}
            source={`${source}.${index}`}
            value={document}
            onChangeCallback={(newValue: any) => {
              updateDocument(index, newValue[`${source}.${index}`]);
            }}
            onRemove={() => removeDocument(index)}
            showRemove={documents.length > 1}
          />
        ))}

        {documents.length < 10 && (
          <Box sx={{ display: 'flex', justifyContent: 'flex-start', marginTop: '16px' }}>
            <Button
              variant="text"
              startIcon={<AddIcon />}
              onClick={addDocument}
              sx={{
                alignSelf: 'flex-start',
                textTransform: 'none',
                fontSize: '14px',
              }}
            >
              Add document
            </Button>
          </Box>
        )}
      </Stack>
    </Box>
  );
};

export default CardIdentityDocumentListInput;
